import { render, staticRenderFns } from "./4-1.Performace.vue?vue&type=template&id=7e9132ad&scoped=true"
import script from "./4-1.Performace.vue?vue&type=script&lang=js"
export * from "./4-1.Performace.vue?vue&type=script&lang=js"
import style0 from "./4-1.Performace.vue?vue&type=style&index=0&id=7e9132ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9132ad",
  null
  
)

export default component.exports